<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')">
      <template v-slot:title>
        {{ readonly ? "Просмотр" : "Редактирование" }}
      </template>
      <v-row>
        <v-col cols="12">
          <a-form-model v-model="data" :model="model" :config="{ readonly, dense: true }" :errors="errors" @validate="validate($event)" />
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save v-if="!readonly" @click="submit()"></a-btn-save>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getAccess, getForm, submitForm } from "@/components/mixings";

export default {
  components: {},
  mixins: [getAccess, getForm, submitForm],
  props: {
    dataTable: Array,
    id: Number,
    value: Boolean,
    RO: Array,
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      m: this.$store.getters["config/get"].models.documentOrderService,
      rowEdit: {},
      rows: [],
      selectedCategory: null,
    };
  },
  computed: {
    model() {
      let model = JSON.parse(JSON.stringify(this.m.formDetail));
      model.forEach((el) => {
        if (this.RO.includes(el.name)) el.readonly = true;
        if (el.dir == "service") {
          //el.dirFilter = { formula: `((d) => {return d.status !== 2 && d.category_id==${this.selectedCategory ? this.selectedCategory : -1};})` };
          el.dirFilter = { formula: `(d) => {return  d.category_id==${this.selectedCategory ? this.selectedCategory : -1};}` };
        }
        if (el.dir == "category") {
          el.dirFilter = { formula: `((d) => {return d.status !== 2 && d.type==1;})` };
        }
        if (el?.sourceList) {
          //если список вариантов находится во внешнем массиве, присоединяю его
          el.options = this.m?.[el.sourceList]
            ? this.m[el.sourceList].filter((list) => {
                return !list?.hidden;
              })
            : [];
        }
      });
      return model;
    },
  },
  created() {
    /*     if (this.id) {
      this.rows = JSON.parse(JSON.stringify(this.dataTable));
      this.row = this.rows.find((el) => el.id == this.id);
    } */
    this.updateData(this.id);
  },
  watch: {
    id(v) {
      if (v) this.row = this.dataTable.find((el) => el.id == v);
    },
    value() {
      if (this.value) {
        if (this.id) this.row = this.dataTable.find((el) => el.id == this.id);
      }
    },
    "data.category_id"(v) {
      this.selectedCategory = v;
    },
  },
  methods: {
    fetchData() {
      this.rows = JSON.parse(JSON.stringify(this.dataTable));
      if (this.id) {
        this.loading = true;
        this.rowEdit = this.rows.find((el) => el.id == this.id);
        this.loading = false;
        for (const name in this.rowEdit) {
          this.$set(this.data, name, this.rowEdit[name]);
        }
      }
    },
    post() {
      let rows = [];
      this.rows.forEach((r) => {
        if (r.id == this.id) {
          rows.push(this.data);
        } else {
          rows.push(r);
        }
      });
      if (!this.id) {
        rows.push(this.data);
      }

      this.$emit("save", rows);

      this.$emit("input");
    },
  },
};
</script>
